import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

import axios from "axios";

function Addshift() {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const routeLocation = useLocation();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [form, setForm] = useState({
        shift_id: "",
        shift_name: "",
        shift_from_time: "",
        shift_to_time: "",
        school_id: "",
        is_active: "",
    })

    useEffect(() => {
        if (routeLocation.state?.shiftData) {
            const shiftData = routeLocation.state.shiftData;
            setForm(shiftData);
            setEditId(shiftData.shift_id);
            window.history.replaceState({}, document.title);
        }
    }, [routeLocation]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            shift_name: form.shift_name || "",
            shift_from_time: form.shift_from_time || "",
            shift_to_time: form.shift_to_time || "",
            school_id: userObj.school_id,
            is_active: form.is_active || "A",
            action: editId !== null ? "UPDATE" : "CREATE"
        };

        if (editId !== null) {
            formData.shift_id = editId;
        }

        try {
            console.log(formData);
            const response = await axios.post(baseUrl + "/shiftmaster/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("API Response" + response);
            setForm({
                shift_name: "",
                shift_from_time: "",
                shift_to_time: "",
                school_id: "",
            });
            if (editId !== null) {
                toast.success("Record Updated Successfully");

            } else {
                toast.success("Record Added Successfully");

            }
        } catch (error) {
            console.error("Error submitting data:", error.response?.data || error.message);
            if (error.response?.data?.error?.includes("already exists")) {
                toast.error("Record already exists");
            } else {
                toast.error("Unexpected error occurred");
            }
        }
    };

    return (


                <div className='pageBody'>
                    <ToastContainer />
                    <Container fluid>

                        <div className=''>
                            <Card>

                                <Card.Body>
                                    <form className="" onSubmit={handleSubmit}>

                                        <div className=''>
                                            <Row>
                                                <Col xs={12}>
                                                    <h6 className='commonSectionTitle'>Shift Details</h6>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={6} lg={4} xxl={3}>
                                                    <div className='commonInput'>
                                                        <Form.Group>
                                                            <Form.Label>Shift Name<span className='requiredStar'>*</span></Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                id="shift_name"
                                                                value={form.shift_name}
                                                                placeholder='Enter Shift Name'
                                                                maxLength={50}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={6} lg={4} xxl={3}>
                                                    <div className='commonInput'>
                                                        <Form.Group>
                                                            <Form.Label>Shift From Time<span className='requiredStar'>*</span></Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="time"
                                                                id="shift_from_time"
                                                                value={form.shift_from_time}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={6} lg={4} xxl={3}>
                                                    <div className='commonInput'>
                                                        <Form.Group>
                                                            <Form.Label>Shift To Time<span className='requiredStar'>*</span></Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="time"
                                                                id="shift_to_time"
                                                                min={form.shift_from_time}
                                                                value={form.shift_to_time}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    o className="btn-info clearBtn"
                                                    onClick={() => setForm({
                                                        shift_name:"",
                                                        shift_from_time: "",
                                                        shift_to_time: "",
                                                    })}
                                                >
                                                    Reset
                                                </Button>
                                            </div>
                                            <div>
                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    className="btn-danger secondaryBtn me-2"
                                                    onClick={() => window.history.back()}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="primary"
                                                    className="btn-success primaryBtn"
                                                >
                                                    Submit
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>
              
        </div>

    );
}

export default Addshift;